import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {InsoleCadProcessSummaryModel} from './insoleCadProcessSummary.model';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class InsoleCadProcessSummaryConverter extends HttpModelConverter<InsoleCadProcessSummaryModel> {
    protected createInstance(): InsoleCadProcessSummaryModel {
        return new InsoleCadProcessSummaryModel();
    }

    protected enrichObject(result: InsoleCadProcessSummaryModel, src: InsoleCadProcessSummaryModel) {
    }
}
